import { useState } from "react";
import { useIntl, FormattedMessage } from "react-intl";
import LocationOnIcon from "@material-ui/icons/LocationOn";
import Grid from "@material-ui/core/Grid";
import Modal from "@material-ui/core/Modal";
import Paper from "@material-ui/core/Paper";
import { InputField } from "../input-field/InputField";
import { InputButton } from "../input-button/InputButton";
import { useStyles } from "./LocationPicker.style";
import { GoogleMapContainer } from "./GoogleMapContainer";

interface LocationPickerProps {
  latitude?: string;
  latitudeFieldName?: string;
  onChangeLatitude: (event: any) => void;
  errorOnLatitude?: boolean;
  helperTextOnLatitude?: string | any;
  longitude?: string;
  longitudeFieldName?: string;
  onChangeLongitude: (event: any) => void;
  errorOnLongitude?: boolean;
  helperTextOnLongitude: string | any;
  onSelectionCallback: (latitude: string, longitude: string) => void;
}

export const LocationPicker = (props: LocationPickerProps) => {
  const classes = useStyles();
  const { formatMessage } = useIntl();
  const {
    latitude,
    latitudeFieldName,
    onChangeLatitude,
    errorOnLatitude,
    helperTextOnLatitude,
    longitude,
    longitudeFieldName,
    onChangeLongitude,
    errorOnLongitude,
    helperTextOnLongitude,
    onSelectionCallback,
  } = props;
  const [mapOpened, setMapOpened] = useState(false);
  const [currentLatitude, setCurrentLatitude] = useState(null);
  const [currentLongitude, setCurrentLongitude] = useState(null);

  const openMap = async () => {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(function (position) {
        setCurrentLatitude(position.coords.latitude);
        setCurrentLongitude(position.coords.longitude);
        setMapOpened(true);
      });
    }
  };

  const closeMap = () => setMapOpened(false);

  const mapClick = (latitude: string, longitude: string) => {
    setMapOpened(false);
    onSelectionCallback(latitude, longitude);
  };

  return (
    <>
      <Modal className={classes.modal} open={mapOpened} onClose={closeMap}>
        <Paper className={classes.modalBody}>
          <GoogleMapContainer
            latitude={currentLatitude}
            longitude={currentLongitude}
            onSelectionCallback={mapClick}
          />
        </Paper>
      </Modal>
      <Grid
        spacing={1}
        item
        container
        xs={12}
        sm={12}
        lg={12}
        alignItems="flex-end"
      >
        <Grid item xs={5} sm={5} lg={5}>
          <InputField
            value={latitude}
            fullWidth
            label={formatMessage({ id: "sharedScreen.latitude" })}
            name={latitudeFieldName ?? "latitude"}
            onChange={onChangeLatitude}
            error={errorOnLatitude}
            helperText={helperTextOnLatitude}
          />
        </Grid>
        <Grid item xs={5} sm={5} lg={5}>
          <InputField
            value={longitude}
            fullWidth
            label={formatMessage({ id: "sharedScreen.longitude" })}
            name={longitudeFieldName ?? "longitude"}
            onChange={onChangeLongitude}
            error={errorOnLongitude}
            helperText={helperTextOnLongitude}
          />
        </Grid>
        <Grid item xs={2} sm={2} lg={2}>
          <InputButton
            className={classes.mapButton}
            fullWidth
            variant="outlined"
            color="secondary"
            onClick={openMap}
          >
            <LocationOnIcon /> <FormattedMessage id="sharedScreen.map" />
          </InputButton>
        </Grid>
      </Grid>
    </>
  );
};
